import FetchData from '@shared/utils/fetchData/fetchData';

import { CartProductList, SelectCartProductsRequest } from '../../';

export const selectCartProduct = async (data: SelectCartProductsRequest) => {
  return await FetchData.post<CartProductList>('cart/toggle', {
    body: JSON.stringify({ data })
  });
};
